// Tiny error boundary — swallows unexpected errors from a child so a bug
// in an optional overlay (like SpellSuggest) can never blank the whole app.
import React from 'react';

export default class SilentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    // Log to console only; no user-facing UI.
    // eslint-disable-next-line no-console
    console.warn('SilentErrorBoundary caught:', error);
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
